import { Roles } from "~enums/roles";

const getHockeyTranslation = (role: Roles) => {
  switch (role) {
    case Roles.Timer:
      return "TIMER_HOCKEY";
    case Roles.Scorer:
      return "SCORER_HOCKEY";
    default:
      return role;
  }
};

const getBasketballTranslation = (role: Roles) => {
  switch (role) {
    case Roles.ScorerAssistant:
      return "SCORER_ASSISTANT_BASKETBALL";
    case Roles.Scorer:
      return "SCORER_BASKETBALL";
    case Roles.Timer:
      return "TIMER_BASKETBALL";
    default:
      return role;
  }
};

const getHandballTranslation = (role: Roles) => {
  switch (role) {
    case Roles.HandballScorer:
      return "SCORER";
    default:
      return role;
  }
};

export const getRoleTranslationKey = (role: Roles, sport: string) => {
  switch (sport) {
    case "hockey":
      return getHockeyTranslation(role);
    case "basketball":
      return getBasketballTranslation(role);
    case "handball":
      return getHandballTranslation(role);
    default:
      return role;
  }
};
